import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../modules/Auth/login";
// import Register from "../modules/Auth/register";
import Dashboard from "../modules/Dashboard";
import CategoryList from "../modules/Category/CategoryList";
import CategoryAdd from "../modules/Category/CategoryAddNew";
import CategoryEdit from "../modules/Category/CategoryEditNew";
// import SubCategoryList from "../modules/SubCategory/SubCategoryList";
import BlogList from "../modules/Blog/BlogList";
import BlogAdd from "../modules/Blog/BlogAddNew";
import BlogEdit from "../modules/Blog/BlogEditNew";
import MarketAreaList from "../modules/MarketArea/MarketAreaList";
import MarketAreaAdd from "../modules/MarketArea/MarketAreaAddNew";
import MarketAreaEdit from "../modules/MarketArea/MarketAreaEditNew";
import GalleryList from "../modules/Gallery/GalleryList";
import GalleryAdd from "../modules/Gallery/GalleryAddNew";
import GalleryEdit from "../modules/Gallery/GalleryEditNew";
// import SettingList from "../modules/Settings/SettingList";
import TestimonialList from "../modules/Testimonial/TestimonialList";
import TestimonialAdd from "../modules/Testimonial/TestimonialAddNew";
import TestimonialEdit from "../modules/Testimonial/TestimonialEditNew";
import TeamList from "../modules/Team/TeamList";
import TeamAdd from "../modules/Team/TeamAddNew";
import TeamEdit from "../modules/Team/TeamEditNew";
import InquiryList from "../modules/Inquiry/InquiryList";
import ProductList from "../modules/Product/ProductList";
import ProductAdd from "../modules/Product/ProductAddNew";
import ProductEdit from "../modules/Product/ProductEditNew";
import PartnerList from "../modules/Partner/PartnerList";
import PartnerAdd from "../modules/Partner/PartnerAddNew";
import PartnerEdit from "../modules/Partner/PartnerEditNew";

import General from "../modules/Pages/GeneralList";
import CompanyDetail from "../modules/Pages/CompanyDetailsList";
import Domain from "../modules/Pages/DomainList";
import SocialLink from "../modules/Pages/SocialLinkList";
import Logo from "../modules/Pages/LogoList";
import Analytic from "../modules/Pages/AnalyticsList";
import HomePage from "../modules/Pages/HomePage/HomePageList";
import AboutUs from "../modules/Pages/HomePage/AboutUsList";
import PrivacyPolicy from "../modules/Pages/HomePage/PrivacyPolicyList";
import TermsAndConditions from "../modules/Pages/HomePage/TermsAndConditionsList";
import SeoConfiguration from "../modules/Pages/SeoConfigurationList";

import ChildCategoryList from "../modules/ChildCategory/ChildCategoryList";
import ChildCategoryAdd from "../modules/ChildCategory/ChildCategoryAddNew";
import ChildCategoryEdit from "../modules/ChildCategory/ChildCategoryEditNew";

import OrganizationDashboard from "../modules/OrganizationDashboard";

import OrganizationList from "../modules/Organization/OrganizationList";
import OrganizationAdd from "../modules/Organization/OrganizationAddNew";
// import OrganizationEdit from "../modules/Organization/OrganizationEditNew";

import BusinessTypeList from "../modules/BusinessType/BusinessTypeList";
import BusinessTypeAdd from "../modules/BusinessType/BusinessTypeAddNew";
import BusinessTypeEdit from "../modules/BusinessType/BusinessTypeEditNew";

import OrganizationTypeList from "../modules/OrganizationType/OrganizationTypeList";
import OrganizationTypeAdd from "../modules/OrganizationType/OrganizationTypeAddNew";
import OrganizationTypeEdit from "../modules/OrganizationType/OrganizationTypeEditNew";

import LegalFirmList from "../modules/LegalFirm/LegalFirmList";
import LegalFirmAdd from "../modules/LegalFirm/LegalFirmAddNew";
import LegalFirmEdit from "../modules/LegalFirm/LegalFirmEditNew";

import CountryList from "../modules/Country/CountryList";
import CountryAdd from "../modules/Country/CountryAddNew";
import CountryEdit from "../modules/Country/CountryEditNew";

import StateList from "../modules/State/StateList";
import StateAdd from "../modules/State/StateAddNew";
import StateEdit from "../modules/State/StateEditNew";

import CityList from "../modules/City/CityList";
import CityAdd from "../modules/City/CityAddNew";
import CityEdit from "../modules/City/CityEditNew";

import TemplateList from "../modules/Template/TemplateList";
import TemplateAdd from "../modules/Template/TemplateAddNew";
import TemplateEdit from "../modules/Template/TemplateEditNew";

import PageList from "../modules/Page/PageList";
import PageAdd from "../modules/Page/PageAddNew";
import PageEdit from "../modules/Page/PageEditNew";
import PageView from "../modules/Page/PageView";

import SubCategoryProductAdd from "../modules/SubCategoryProduct/SubCategoryProductAddNew";
import SubCategoryProductEdit from "../modules/SubCategoryProduct/SubCategoryProductEditNew";
import SubCategoryProductList from "../modules/SubCategoryProduct/SubCategoryProductList";

import GalleryCategoryAdd from "../modules/GalleryCategory/GalleryCategoryAddNew";
import GalleryCategoryEdit from "../modules/GalleryCategory/GalleryCategoryEditNew";
import GalleryCategoryList from "../modules/GalleryCategory/GalleryCategoryList";

import GalleryImageAdd from "../modules/GalleryImage/GalleryImageAddNew";
import GalleryImageEdit from "../modules/GalleryImage/GalleryImageEditNew";
import GalleryImageList from "../modules/GalleryImage/GalleryImageList";

import GalleryVideoAdd from "../modules/GalleryVideo/GalleryVideoAddNew";
import GalleryVideoEdit from "../modules/GalleryVideo/GalleryVideoEditNew";
import GalleryVideoList from "../modules/GalleryVideo/GalleryVideoList";

import FaqAdd from "../modules/FrequentlyAskedQuestion/FaqAddNew";
import FaqEdit from "../modules/FrequentlyAskedQuestion/FaqEditNew";
import FaqList from "../modules/FrequentlyAskedQuestion/FaqList";

import PlanConfiguration from "../modules/Pages/PlanConfiguration";

import NotFound from "../components/NotFound";

import CommonLayout from "../layouts";
import { AuthProvider } from "../context/AuthContext";
import { LoaderProvider } from "../context/LoaderContext";
import Loader from "../components/loader";
import PrivateRouteLayout from "./PrivateRouteLayout";
import ColorManagerCard from "../modules/ThemeConfiguration/ColorCardManager";

const AppRoutes = () => (
  <AuthProvider>
    <LoaderProvider>
      <Loader />
      <Router>
        <Routes>
          <Route exact path="/login" element={<Login />} />
          {/* <Route exact path="/register" element={<Register />} /> */}
          <Route path="/" element={<PrivateRouteLayout />}>
            <Route path="/" element={<CommonLayout />}>
              {/* Main page route start :- */}
              <Route exact path="/" element={<Dashboard />} />
              <Route
                exact
                path="/organizations"
                element={<OrganizationList />}
              />
              <Route
                exact
                path="/organization-add"
                element={<OrganizationAdd />}
              />
              {/* <Route exact path="/organization-edit/:id" element={<OrganizationEdit />} /> */}

              <Route
                exact
                path="/business-types"
                element={<BusinessTypeList />}
              />
              <Route
                exact
                path="/business-type-add"
                element={<BusinessTypeAdd />}
              />
              <Route
                exact
                path="/business-type-edit/:id"
                element={<BusinessTypeEdit />}
              />

              <Route
                exact
                path="/organization-types"
                element={<OrganizationTypeList />}
              />
              <Route
                exact
                path="/organization-type-add"
                element={<OrganizationTypeAdd />}
              />
              <Route
                exact
                path="/organization-type-edit/:id"
                element={<OrganizationTypeEdit />}
              />

              <Route exact path="/legal-firms" element={<LegalFirmList />} />
              <Route exact path="/legal-firm-add" element={<LegalFirmAdd />} />
              <Route
                exact
                path="/legal-firm-edit/:id"
                element={<LegalFirmEdit />}
              />

              <Route exact path="/countries" element={<CountryList />} />
              <Route exact path="/country-add" element={<CountryAdd />} />
              <Route exact path="/country-edit/:id" element={<CountryEdit />} />

              <Route exact path="/states" element={<StateList />} />
              <Route exact path="/state-add" element={<StateAdd />} />
              <Route exact path="/state-edit/:id" element={<StateEdit />} />

              <Route exact path="/cities" element={<CityList />} />
              <Route exact path="/city-add" element={<CityAdd />} />
              <Route exact path="/city-edit/:id" element={<CityEdit />} />

              <Route exact path="/templates" element={<TemplateList />} />
              <Route exact path="/template-add" element={<TemplateAdd />} />
              <Route
                exact
                path="/template-edit/:id"
                element={<TemplateEdit />}
              />

              {/* Main page route end :- */}

              {/* Particular Organization route start :- */}

              <Route
                exact
                path="/organization/:id"
                element={<OrganizationDashboard />}
              />
              <Route
                exact
                path="/organization/:id/blogs"
                element={<BlogList />}
              />
              <Route
                exact
                path="/organization/:id/blog-add"
                element={<BlogAdd />}
              />
              <Route
                exact
                path="/organization/:id/blog-edit/:id"
                element={<BlogEdit />}
              />
              <Route
                exact
                path="/organization/:id/target-regions"
                element={<MarketAreaList />}
              />
              <Route
                exact
                path="/organization/:id/target-region-add"
                element={<MarketAreaAdd />}
              />
              <Route
                exact
                path="/organization/:id/target-region-edit/:id"
                element={<MarketAreaEdit />}
              />
              <Route
                exact
                path="/organization/:id/galleries"
                element={<GalleryList />}
              />
              <Route
                exact
                path="/organization/:id/gallery-add"
                element={<GalleryAdd />}
              />
              <Route
                exact
                path="/organization/:id/gallery-edit/:id"
                element={<GalleryEdit />}
              />
              {/* <Route exact path="/settings" element={<SettingList />} /> */}
              <Route
                exact
                path="/organization/:id/categories"
                element={<CategoryList />}
              />
              <Route
                exact
                path="/organization/:id/category-add"
                element={<CategoryAdd />}
              />
              <Route
                exact
                path="/organization/:id/category-edit/:id"
                element={<CategoryEdit />}
              />
              {/* <Route exact path="/sub-categories" element={<SubCategoryList />} /> */}
              <Route
                exact
                path="/organization/:id/testimonials"
                element={<TestimonialList />}
              />
              <Route
                exact
                path="/organization/:id/testimonial-add"
                element={<TestimonialAdd />}
              />
              <Route
                exact
                path="/organization/:id/testimonial-edit/:id"
                element={<TestimonialEdit />}
              />
              <Route
                exact
                path="/organization/:id/teams"
                element={<TeamList />}
              />
              <Route
                exact
                path="/organization/:id/team-add"
                element={<TeamAdd />}
              />
              <Route
                exact
                path="/organization/:id/team-edit/:id"
                element={<TeamEdit />}
              />
              <Route
                exact
                path="/organization/:id/inquiries"
                element={<InquiryList />}
              />
              <Route
                exact
                path="/organization/:id/products"
                element={<ProductList />}
              />
              <Route
                exact
                path="/organization/:id/product-add"
                element={<ProductAdd />}
              />
              <Route
                exact
                path="/organization/:id/product-edit/:id"
                element={<ProductEdit />}
              />

              <Route
                exact
                path="/organization/:id/clients"
                element={<PartnerList />}
              />
              <Route
                exact
                path="/organization/:id/client-add"
                element={<PartnerAdd />}
              />
              <Route
                exact
                path="/organization/:id/client-edit/:id"
                element={<PartnerEdit />}
              />

              <Route
                exact
                path="/organization/:id/general"
                element={<General />}
              />
              <Route
                exact
                path="/organization/:id/company-details"
                element={<CompanyDetail />}
              />
              <Route
                exact
                path="/organization/:id/domain"
                element={<Domain />}
              />
              <Route
                exact
                path="/organization/:id/social-links"
                element={<SocialLink />}
              />
              <Route exact path="/organization/:id/logo" element={<Logo />} />
              <Route
                exact
                path="/organization/:id/google-analytics"
                element={<Analytic />}
              />
              <Route
                exact
                path="/organization/:id/home-page"
                element={<HomePage />}
              />
              <Route
                exact
                path="/organization/:id/about-us"
                element={<AboutUs />}
              />
              <Route
                exact
                path="/organization/:id/privacy-policy"
                element={<PrivacyPolicy />}
              />
              <Route
                exact
                path="/organization/:id/terms-conditions"
                element={<TermsAndConditions />}
              />
              <Route
                exact
                path="/organization/:id/seo-configuration"
                element={<SeoConfiguration />}
              />

              <Route
                exact
                path="/organization/:id/child-categories/:id"
                element={<ChildCategoryList />}
              />
              <Route
                exact
                path="/organization/:id/child-category-add/:id"
                element={<ChildCategoryAdd />}
              />
              <Route
                exact
                path="/organization/:id/child-category-edit/:id"
                element={<ChildCategoryEdit />}
              />

              <Route
                exact
                path="/organization/:id/sub-category-products/:id"
                element={<SubCategoryProductList />}
              />
              <Route
                exact
                path="/organization/:id/sub-category-product-add/:id"
                element={<SubCategoryProductAdd />}
              />
              <Route
                exact
                path="/organization/:id/sub-category-product-edit/:id"
                element={<SubCategoryProductEdit />}
              />

              <Route
                exact
                path="/organization/:id/gallery-categories"
                element={<GalleryCategoryList />}
              />
              <Route
                exact
                path="/organization/:id/gallery-category-add"
                element={<GalleryCategoryAdd />}
              />
              <Route
                exact
                path="/organization/:id/gallery-category-edit/:id"
                element={<GalleryCategoryEdit />}
              />

              <Route
                exact
                path="/organization/:id/gallery-images"
                element={<GalleryImageList />}
              />
              <Route
                exact
                path="/organization/:id/gallery-image-add"
                element={<GalleryImageAdd />}
              />
              <Route
                exact
                path="/organization/:id/gallery-image-edit/:id"
                element={<GalleryImageEdit />}
              />

              <Route
                exact
                path="/organization/:id/gallery-videos"
                element={<GalleryVideoList />}
              />
              <Route
                exact
                path="/organization/:id/gallery-video-add"
                element={<GalleryVideoAdd />}
              />
              <Route
                exact
                path="/organization/:id/gallery-video-edit/:id"
                element={<GalleryVideoEdit />}
              />

              <Route
                exact
                path="/organization/:id/faqs"
                element={<FaqList />}
              />
              <Route
                exact
                path="/organization/:id/faq-add"
                element={<FaqAdd />}
              />
              <Route
                exact
                path="/organization/:id/faq-edit/:id"
                element={<FaqEdit />}
              />

              <Route
                exact
                path="/organization/:id/pages"
                element={<PageList />}
              />
              <Route
                exact
                path="/organization/:id/page-add"
                element={<PageAdd />}
              />
              <Route
                exact
                path="/organization/:id/page/:id"
                element={<PageView />}
              />
              <Route
                exact
                path="/organization/:id/page-edit/:id"
                element={<PageEdit />}
              />

              <Route
                exact
                path="/organization/:id/plan-configuration"
                element={<PlanConfiguration />}
              />

              <Route
                exact
                path="/organization/:id/color-configuration"
                element={<ColorManagerCard />}
              />

              <Route path="*" element={<NotFound />} />

              {/* Particular Organization route end :- */}
            </Route>
          </Route>
        </Routes>
      </Router>
    </LoaderProvider>
  </AuthProvider>
);

export default AppRoutes;
